<template>
  <div id="app" data-server-rendered="true">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import store from "vuex"
export default {
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
  },
  mounted () {
    if (this._isMobile()) {
      sessionStorage.setItem("facility", "mobile")
      // console.log("手机端");
    } else {
      sessionStorage.setItem("facility", "pc")
      // console.log("pc端");
    }
    // return;
    // 屏蔽右键
    document.oncontextmenu = new Function("event.returnValue=false")
    document.onkeydown = function (e) {
      // 屏蔽F12
      if (e.keyCode === 123) {
        e.preventDefault()
        e.returnValue = false
        return false
      }
    }
    // 禁用开发者模式
    setInterval(function () {
      function doCheck (a) {
        if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
          (function () { }["constructor"]("debugger")())
        } else {
          (function () { }["constructor"]("debugger")())
        }
        doCheck(++a)
      }
      try {
        doCheck(0)
      } catch (err) { }
    }, 1000);
  },
  created () {
    //1000*60*60*24*7; 604800000
    var oldTimestamp = localStorage.getItem('time'); //以前存的时间戳  let login = localStorage.getItem('login');
    var nowTimestamp = new Date().getTime(); //当前时间戳
    // console.log(oldTimestamp,nowTimestamp,"nowTimestamp");
    // 如果当前时间戳> 前面存的时间戳+过期时间 表示已经过期
    var sumTimestamp = parseInt(oldTimestamp);
    if (oldTimestamp > 0) {
      if (nowTimestamp > sumTimestamp) {
        // console.log("超期");
        this.$store.dispatch('logout')
      } else {
        // console.log("未超期");
      }
    }
    if (location.pathname != "/finalize") {
      this.$store.dispatch('startNoticeInterval')
    }
  },
  beforeDestroy () {
    this.$store.dispatch('stopNoticeInterval')
  }
}
</script>

<style lang="scss">
// 4000 ：76561198079108821
// 3000条数据：76561198209105615
// 200条： 76561199071471934
//  850: 76561198428358718

@font-face {
  font-family: 'font';
  src: url('./assets/font/iconfont.woff')format('woff'),
    url('./assets/font/iconfont.ttf')format('truetype');
  // src: url('../fonts/singlemalta-webfont.eot?#iefix') format('embedded-opentype'),
  //      url('../fonts/singlemalta-webfont.woff') format('woff'),
  //      url('../fonts/singlemalta-webfont.ttf') format('truetype'),
  //      url('../fonts/singlemalta-webfont.svg#defineName') format('svg');
  font-weight: normal;
  font-style: normal;
}

body {
  background-color: #000;
}

//滚动条的哈滑块
// ::-webkit-scrollbar-thumb {
//   background: #2e6190;
//   border-radius: 3px;
// }
// html {
//   overflow-y: overlay;
// }
</style>
